import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Assuming navigation is required
import FindingMatchButton from "./home/finding-match-button";
import FindMatchButton from "./home/find-match-button";
import LoadingModal from "./popups/match-info-popup";
import { assetImages } from "../../constants/assets";
import useApiRequest from "../../api/api";
import apiRoutes from "../../api/routes";

const MatchFinder = ({
  findMatchText = "FIND RANDOM MATCH",
  width = 350,
  py = 6.5,
  onNavigate, // Callback for navigation action
}) => {
  const [isFindMatchActive, setIsFindMatchActive] = useState(false);
  const [open, setOpen] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const { makeApiCall } = useApiRequest();

  const cancelFlag = { cancelled: false };
  let timer, timeoutId, navigationTimeoutId;

  const navigate = useNavigate();

  const handleFindMatchClick = () => {
    if (!isFindMatchActive) {
      setIsFindMatchActive(true);
    }
  };

  const handleFindingMatchClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    const startProcess = () => {
      timer = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);

      timeoutId = setTimeout(async () => {
        if (!cancelFlag.cancelled) {
          const response = await makeApiCall(apiRoutes.races.random, "GET");

          navigationTimeoutId = setTimeout(() => {
            if (!cancelFlag.cancelled) {
              setIsFindMatchActive(false);
              setSeconds(0);
              if (onNavigate) {
                onNavigate(response.data); // Trigger parent navigation callback
              } else {
                navigate(`/race?id=${response.data}`); // Default navigation
              }
            }
          }, 5000);
        }
      }, 3000);
    };

    if (isFindMatchActive) {
      startProcess();
    } else {
      clearInterval(timer);
      clearTimeout(timeoutId);
      clearTimeout(navigationTimeoutId);
      setOpen(false);
    }

    return () => {
      cancelFlag.cancelled = true;
      clearInterval(timer);
      clearTimeout(timeoutId);
      clearTimeout(navigationTimeoutId);
    };
  }, [isFindMatchActive]);

  const handleClose = () => {
    cancelFlag.cancelled = true;
    setIsFindMatchActive(false);
    clearInterval(timer);
    clearTimeout(timeoutId);
    clearTimeout(navigationTimeoutId);
    setSeconds(0);
    setOpen(false);
  };

  return (
    <>
      {isFindMatchActive ? (
        <FindingMatchButton
          backgroundImage={assetImages.findMatchActiveBg}
          width={width}
          onClick={handleFindingMatchClick}
          py={py}
          seconds={seconds}
        />
      ) : (
        <FindMatchButton
          text={findMatchText}
          backgroundImage={assetImages.findMatchBg}
          width={width}
          onClick={handleFindMatchClick}
          py={py}
        />
      )}
      <LoadingModal open={open} onClose={handleClose} timer={seconds} />
    </>
  );
};

export default MatchFinder;
